// extracted by mini-css-extract-plugin
export default {"address-item":"AddressItem_address-item__Pk6bH"};